import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom"; // if using react-router

import logo from "../assets/logo.png"; // 🔁 update filename if needed

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">

          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3"
            onClick={() => setIsOpen(false)}
          >
            <img
              src={logo}
              alt="RetailMitra Logo"
              className="h-20 w-auto"
            />
            {/* <span className="text-2xl font-bold text-slate-900 tracking-tight">
              RetailMitra
            </span> */}
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-600 hover:text-emerald-600 font-medium transition">
              Features
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-emerald-600 font-medium transition">
              How It Works
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-emerald-600 font-medium transition">
              Pricing
            </a>
            <a href="#testimonialgrid" className="text-gray-600 hover:text-emerald-600 font-medium transition">
              Testimonials
            </a>
          </div>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center gap-4">
          <button className="text-emerald-600 font-semibold hover:text-emerald-700">
            Contact Us
          </button>

          <button
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.retailmitra&hl=en_IN",
                "_blank"
              )
            }
            className="bg-emerald-600 text-white px-6 py-2.5 rounded-full font-bold hover:bg-emerald-700 transition shadow-lg shadow-emerald-200"
          >
            Download App
          </button>
        </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 px-4 pt-4 pb-6 space-y-4">
          <a
            href="#features"
            className="block text-lg font-medium text-gray-700"
            onClick={() => setIsOpen(false)}
          >
            Features
          </a>
          <a
            href="#how-it-works"
            className="block text-lg font-medium text-gray-700"
            onClick={() => setIsOpen(false)}
          >
            How It Works
          </a>
          <a
            href="#pricing"
            className="block text-lg font-medium text-gray-700"
            onClick={() => setIsOpen(false)}
          >
            Pricing
          </a>
          <button className="w-full bg-emerald-600 text-white py-3 rounded-xl font-bold">
            Download App
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
